export const financialStatementFeatures = {
  'financial-statement': {
    id: 222,
    featureName: 'Financial Statement',
  },
} as const;
export const financialStatementFeaturesList = Object.entries(financialStatementFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: 'System',
}));

export const financialStatementModuleFeatures = [
  { moduleId: 30, featureId: financialStatementFeatures['financial-statement'].id },
];
